import { Component, Input } from '@angular/core';
import {
  ProvidersService,
  ParentBusiness,
  SystemBusiness
} from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FCEVENT } from '../fc';
import { CommonService } from 'fccore2';
import { FcEvent } from '../business/fcevent.event';
import { CacheService } from 'fccore2';
/**
 * fc-navtabéé¡¹å¡å¯¼èª
 * éé¡¹å¡å¯¼èªç»ä»¶ã
 * æä¾å¹³çº§çåºåå°å¤§ååå®¹è¿è¡æ¶çº³åå±ç°ï¼ä¿æçé¢æ´æ´ã
 * Ant Design ä¾æ¬¡æä¾äºä¸çº§éé¡¹å¡ï¼åå«ç¨äºä¸åçåºæ¯ã
 * äºä»¶
 * 1.éä¸­äºä»¶ï¼selected
 * 2.å³é­äºä»¶ï¼closed
 */
@Component({
  selector: 'fc-navtab',
  template: `
    <nz-tabset class='fc-navtab'  [nzType]='fcType'
    [nzShowPagination]='fcShowPagination'
    [nzSize]='fcSize'
    [nzTabPosition]='fcPosition'
    [(nzSelectedIndex)]='fcSelectedIndex'
    [nzTabBarExtraContent]='extraTemplate'
    >
    <nz-tab *ngFor='let tab of fcTabs' [nzForceRender]="true"
        [nzTitle]='titleTemplate' (nzSelect)='event(fcevent.fcnavtabSelected,tab)' [nzDisabled]="_disabled">
        <ng-template #titleTemplate>
        <div>
            <fc-icon [fcIcon]="tab.data.MENUICON" style="margin-right:2px"></fc-icon>
            {{tab.data.MENUNAME}}
            <i *ngIf="tab.close==='Y'" nz-icon nzType="close" (click)="closeTab(fcevent.fcnavtabClosed,tab)"></i>
        </div>
        </ng-template>
        <div class="content-main" [ngStyle]="{'height':height}">
             <fcnavtabtpl [tab]="tab"></fcnavtabtpl>
        </div>
    </nz-tab>
    </nz-tabset>
    <ng-template #extraTemplate>
      <span title="å³é­ææ" style='cursor: pointer;line-height:28px'>
        <fc-icon fcSize="default" fcIcon="fc-icon-developclose" style="margin-right:10px" (click)="closeAllTab(fcevent.fcnavtabClosed)"></fc-icon>
      </span>
    </ng-template>
    `,
  styles: [
    `
    :host ::ng-deep .ant-tabs-extra-content{
      height:27px!important;
    }
    .ant-tabs-nav .ant-tabs-tab-disabled{

    }
    :host ::ng-deep .ant-tabs-nav-container{
        height:30px!important;
    }
    .fc-navtab{
        padding: 1px 0px 0px;
        box-sizing: border-box;
    }
    :host ::ng-deep .fc-navtab .ant-tabs-bar{
        margin-bottom:0px;
        padding-left:5px;
    }
    :host ::ng-deep .ant-tabs-nav .ant-tabs-tab .anticon{
        width: 12px;
        margin-right: 0px;
    }
    :host ::ng-deep .ant-tabs-nav{
        height:30px;
    }
    .fc-navtab .navtab-icon{
        font-size:12px;
    }
    `
  ]
})
export class FcnavtabComponent extends FcinputComponent {
  @Input()
  fcRoutes: any[];
  name: string;
  fcevent = FcEvent.fcnavtab;
  /** éç½® */
  @Input()
  fcTabs: any[];
  /** éä¸­ç´¢å¼ */
  @Input()
  fcSelectedIndex: number;
  /** è¶åºé«åº¦æå®½åº¦åæ¯å¦æ¾ç¤ºæ»å¨æé® */
  @Input()
  fcShowPagination: boolean = true;
  /** é¡µç­¾çåºæ¬æ ·å¼ï¼å¯é lineãcard ç±»å */
  @Input()
  fcType: string = 'card';
  /** é¡µç­¾ä½ç½®ï¼å¯éå¼æ top right bottom left */
  @Input()
  fcPosition: string = 'top';
  height: string;
  // å½åéä¸­çtab index
  ngOnInit() {
    this.height = window.document.body.clientHeight - 82 + 'px';
    window.onresize = () => {
      this.height = window.document.body.clientHeight - 82 + 'px';
      CommonService.event(this.fcevent.fcnavtabResize, {height: window.document.body.clientHeight - 82, width: window.document.body.clientWidth});
    };
  }
  constructor(public provider: ProvidersService) {
    super(provider, 'fc-navtab');
    this.fcTabs = [];
    this.pushDestroy(
      CommonService.subscribe('selectedMenu', (event: FCEVENT) => {
        if (CacheService.getS('token') !== null) {
          if (event) {
            // // å½è¶è¿11ä¸ªtabé¡µç­¾æ¶å é¤
            // if (this.fcTabs.length > 10) {
            //   this.fcTabs.splice(1, 1);
            //   let i = 0;
            //   this.fcTabs.forEach(item => {
            //     item.index = i++;
            //   });
            //   this.fcSelectedIndex = i;
            // }
            // è·åå½åéä¸­çèå
            const selectMenu1 = event.param;
            // è·åè·¯ç±åç§°
            this.name = selectMenu1.ROUTER;
            // å¨ææçtabä¸­è·åå½åéä¸­çèåç¼ç ç¸åçtabå¯¹è±¡
            const tabOne = this.fcTabs.filter(
              tab => tab.data.MENUID === selectMenu1.MENUID
            );
            // å½æ¾å°tabé¡µé¢æ¶
            if (tabOne.length > 0) {
              // å¾å°æ¾å°çtab
              const tab: any = tabOne[0];
              // å¦æèåæ¯å¯ä»¥å·æ°çå¹¶ä¸æ»tabé¡µæ°å¤§äº1ç
              if (selectMenu1.refresh && this.fcTabs.length > 1) {
                // ä»tabé¡µä¸­å é¤éä¸­çtabé¡µï¼å¼å§éæ°å è½½
                this.fcTabs.splice(this.fcTabs.indexOf(tab), 1);
                // åå§åtabçç´¢å¼ï¼ä¹åå·²ç»å é¤ï¼éè¦éæ°æåº
                let i = 0;
                this.fcTabs.forEach(item => {
                  item.index = i++;
                });
                // éç½®å¯å·æ°ä¸ºfalse
                selectMenu1.refresh = false;
                // è·åææ°çç»ä»¶é¡µé¢
                const components = this.fcRoutes.filter(
                  route => selectMenu1.ROUTER === route.path
                );
                // æå»ºæ°å¯¹è±¡ä½ä¸ºéä¸­çtabé¡µç­¾
                if (components.length > 0) {
                  const tab1: any = {
                    index: tab.index,
                    disable: 'Y',
                    close: 'Y',
                    data: selectMenu1,
                    refresh: false,
                    module: tab.module,
                    component: components[0].component
                  };
                  this.fcTabs.splice(tab.index, 0, tab1);
                  i = 0;
                  this.fcTabs.forEach(item => {
                    item.index = i++;
                  });
                }
              }
              this.fcSelectedIndex = tab.index;
            } else {
              selectMenu1.refresh = false;
              const tab: any = {
                index: this.fcTabs.length,
                disable: 'Y',
                close: 'Y',
                data: selectMenu1,
                refresh: false,
                module: ''
              };
              let component;
              const components = this.fcRoutes.filter(
                route => selectMenu1.ROUTER === route.path
              );
              if (components.length > 0) {
                component = components[0].component;
                tab.module = components[0].data.module;
                tab.component = component;
              }
              if (this.fcTabs.length === 0) {
                tab.disable = 'N';
                tab.close = 'N';
              }
              this.fcTabs.push(tab);
              this.fcSelectedIndex = this.fcTabs.length - 1;
            }
          }
          // å½è¶è¿11ä¸ªtabé¡µç­¾æ¶å é¤
          if (this.fcTabs.length > 10) {
            this.fcTabs.splice(1, 1);
            // åå§åtabçç´¢å¼ï¼ä¹åå·²ç»å é¤ï¼éè¦éæ°æåº
            let i = 0;
            this.fcTabs.forEach(item => {
              item.index = i++;
            });
            setTimeout(() => {
              this.fcSelectedIndex = this.fcTabs.length - 1;
            }, 200);
          }
        } else {
          // æ¸é¤ç¨æ·ç¼å­
          CacheService.clearS();
          // æ³¨éç¨æ·å¹¶è·³è½¬ç»å½é¡µé¢
          SystemBusiness.navigate(['/signin']);
        }
      })
    );
    this.pushDestroy(
      CommonService.subscribe(
        FcEvent.fcnavtab.fcnavtabClose,
        (event: FCEVENT) => {
          if (CacheService.getS('token') !== null) {
            if (event) {
              const selectMenu1 = event.param;
              if (selectMenu1 && selectMenu1.MENUID) {
                const tabOne = this.fcTabs.filter(
                  tab => tab.data.MENUID === selectMenu1.MENUID
                );
                if (tabOne.length > 0) {
                  if (selectMenu1.toTab !== undefined) {
                    this.fcSelectedIndex = selectMenu1.toTab;
                  } else {
                    this.fcSelectedIndex = tabOne[0].index;
                  }
                  this.event(FcEvent.fcnavtab.fcnavtabClosed, tabOne[0]);
                  this.closeTab(FcEvent.fcnavtab.fcnavtabClose, tabOne[0]);
                } else {
                  ParentBusiness.msgService.error(
                    'å³é­tabå¤±è´¥ï¼æ¾ä¸å°tabéé¡¹å¡'
                  );
                }
              } else {
                const tabOne = this.fcTabs.filter(
                  tab => tab.index === this.fcSelectedIndex
                );
                this.fcSelectedIndex = tabOne[0].index;
                this.event(FcEvent.fcnavtab.fcnavtabSelected, tabOne[0]);
                this.closeTab(FcEvent.fcnavtab.fcnavtabClose, tabOne[0]);
              }
            }
          } else {
            // æ¸é¤ç¨æ·ç¼å­
            CacheService.clearS();
            // æ³¨éç¨æ·å¹¶è·³è½¬ç»å½é¡µé¢
            SystemBusiness.navigate(['/signin']);
          }
        }
      )
    );
    this.pushDestroy(
      CommonService.subscribe(
        FcEvent.fcnavtab.fcnavtabCloseOther,
        (event: FCEVENT) => {
          if (event) {
            const selectMenu1 = event.param;
            if (selectMenu1 && selectMenu1.MENUID) {
              const tabOnes = this.fcTabs.filter(tab => {
                if (tab.close === 'N') {
                  return false;
                } else {
                  return tab.data.MENUID !== selectMenu1.MENUID;
                }
              });
              tabOnes.forEach(tabOne => {
                this.fcSelectedIndex = tabOne.index;
                this.event(FcEvent.fcnavtab.fcnavtabClosed, tabOne);
                this.closeTab(FcEvent.fcnavtab.fcnavtabClose, tabOne);
              });
            }
          }
        }
      )
    );
  }
  _afterParentInit() {
    /** ç¦ç¨åé¨è½¬æ¢ */
    if (this.fcDisabled === undefined || this.fcDisabled === 'N') {
      this._disabled = false;
    } else if (this.fcDisabled === 'Y') {
      this._disabled = true;
    }
  }
  /**
   * å³é­tabé¡µé¢
   * @param eventName äºä»¶åç§°
   * @param tab å³é­çtabé¡µé¢
   */
  closeTab(eventName, tab: any) {
    if (tab.close === 'Y' && tab.component.prototype.canClosed(tab.component)) {
      this.fcTabs.splice(this.fcTabs.indexOf(tab), 1);
      let i = 0;
      this.fcTabs.forEach(item => {
        item.index = i++;
      });
      if (this.fcTabs.length > 0) {
        if (this.fcSelectedIndex && tab.index === this.fcSelectedIndex) {
          const data = this.fcTabs[this.fcSelectedIndex - 1].data;
          data.refresh = false;
          CommonService.event('selectedMenu', data);
        } else if (this.fcSelectedIndex && tab.index < this.fcSelectedIndex) {
          this.fcSelectedIndex = tab.index;
          const data = this.fcTabs[this.fcSelectedIndex].data;
          data.refresh = false;
          CommonService.event('selectedMenu', data);
        }
      }
      this.event(eventName, tab);
    }
  }

  closeAllTab(eventName) {
      this.fcTabs.splice(1, this.fcTabs.length - 1);
      let i = 0;
      this.fcTabs.forEach(item => {
        item.index = i++;
      });

      if (this.fcTabs.length > 0) {
          this.fcSelectedIndex = this.fcTabs[0].index;
          const data = this.fcTabs[0].data;
          data.refresh = false;
          CommonService.event('selectedMenu', data);
      }
      this.event(eventName, {});
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.fcTabs = [];
  }
}